'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var loadQueryParameters = exports.loadQueryParameters = function loadQueryParameters() {
  var result = {};

  if (!window.location.search) {
    return result;
  }

  var params = window.location.search.substr(1).split('&');

  for (var i = 0; i < params.length; i++) {
    var p = params[i].split('=');
    var key = p[0];
    var value = decodeURI(p[1]);
    result[key] = value;
  }

  return result;
};

/**
 * Gets query parameter value for given string key. Defaults to null if not found
 * @param {string} key 
 * @returns {string}
 */
var getQueryParameter = exports.getQueryParameter = function getQueryParameter(key) {
  var params = window.location.search.substr(1).split('&');

  for (var i = 0; i < params.length; i++) {
    var p = params[i].split('=');
    if (p[0] === key) {
      return decodeURI(p[1]);
    }
  }

  return undefined;
};

/**
 * Gets query parameter value for boolean
 * Only returns true if value is 'true'. Defaults to false otherwise
 * @param {string} key 
 * @returns {boolean}
 */
var getQueryParameterBoolean = exports.getQueryParameterBoolean = function getQueryParameterBoolean(key) {
  var value = getQueryParameter(key);
  return value && value.toLowerCase() === 'true' ? true : false;
};

/**
 * Gets app module data query parameters from URL
 * @returns {any}
 */
var getQueryParameters = exports.getQueryParameters = function getQueryParameters() {
  var site = getQueryParameter('site');
  var companyName = getQueryParameter('companyName');
  var memberId = getQueryParameter('memberId');

  var locale = getQueryParameter('locale');
  var localeVersion = getQueryParameter('localeVersion');

  var screenId = getQueryParameter('screenId');
  var screenArgs = getQueryParameter('screenArgs');

  var userOS = getQueryParameter('userOS');
  var userBrowser = getQueryParameter('userBrowser');
  var userSessionId = getQueryParameter('userSessionId');
  var appSessionId = getQueryParameter('appSessionId');
  var sessionTag = getQueryParameter('sessionTag');

  return {
    site: site,
    companyName: companyName,
    memberId: memberId,
    locale: locale,
    localeVersion: localeVersion,
    screenId: screenId,
    screenArgs: screenArgs ? JSON.parse(screenArgs) : undefined,
    userOS: userOS,
    userBrowser: userBrowser,
    userSessionId: userSessionId,
    appSessionId: appSessionId,
    sessionTag: sessionTag
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/QueryParameterService.js
// module id = 222
// module chunks = 10